<div class="standard-timespan-container">
    <form [formGroup]="form" class="standard-timespan-form">
        @if (label) {
            <label class="standard-timespan-label" id="timespan-label" [for]="id">{{ label }}</label>
        }

        <div class="input-group">
            <div class="standard-timespan-part">
                <label [for]="id + '-hours'" class="standard-timespan-input-label">{{ 'time.hours' | translation | async }}</label>
                <input
                    type="number"
                    formControlName="hours"
                    [placeholder]="'time.hours' | translation | async"
                    [min]="minHours"
                    [max]="maxHours"
                    class="form-control standard-timespan-input"
                    [value]="hoursControl.value | number: numberFormat"
                    id="timespan-hours-input"
                    [name]="id + '-hours'"
                    [readonly]="disabled"
                />
            </div>

            <span class="time-parts-divider"> : </span>

            <div class="standard-timespan-part">
                <label [for]="id + '-minutes'" class="standard-timespan-input-label">{{ 'time.minutes' | translation | async }}</label>
                <input
                    type="number"
                    formControlName="minutes"
                    [placeholder]="'time.minutes' | translation | async"
                    min="0"
                    max="59"
                    class="form-control standard-timespan-input"
                    [value]="minutesControl.value | number: numberFormat"
                    id="timespan-minutes-input"
                    [name]="id + '-minutes'"
                    [readonly]="disabled"
                />
            </div>

            <span class="time-parts-divider"> : </span>

            <div class="standard-timespan-part">
                <label [for]="id + '-seconds'" class="standard-timespan-input-label">{{ 'time.seconds' | translation | async }}</label>
                <input
                    type="number"
                    formControlName="seconds"
                    [placeholder]="'time.seconds' | translation | async"
                    min="0"
                    max="59"
                    class="form-control standard-timespan-input"
                    [value]="secondsControl.value | number: numberFormat"
                    id="timespan-seconds-input"
                    [name]="id + '-seconds'"
                    [readonly]="disabled"
                />
            </div>
        </div>

        @if (form.invalid) {
            <div class="form-text text-danger">
                @if (form.errors?.isBelowMinTimespan) {
                    <div id="min-timespan-error"><i class="fas fa-exclamation-circle"></i> {{ 'standardTimespan.validation.isBelowMinTimespan' | translation: { minValue } | async }}</div>
                } @else {
                    @if (form.errors?.isAboveMaxTimespan) {
                        <div id="max-timespan-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.isAboveMaxTimespan' | translation: { maxValue } | async }}</div>
                    } @else {
                        @if (hoursControl?.errors?.required) {
                            <div id="timespan-hours-required-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.hoursRequired' | translation | async }}</div>
                        }
                        @if (hoursControl?.errors?.min || hoursControl?.errors?.max) {
                            <div id="timespan-hours-range-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.hoursRange' | translation: { maxHours: $any(maxHours) } | async }}</div>
                        }
                        @if (minutesControl?.errors?.required) {
                            <div id="timespan-minutes-required-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.minutesRequired' | translation | async }}</div>
                        }
                        @if (minutesControl?.errors?.min || minutesControl?.errors?.max) {
                            <div id="timespan-minutes-range-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.minutesRange' | translation | async }}</div>
                        }
                        @if (secondsControl?.errors?.required) {
                            <div id="timespan-seconds-required-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.secondsRequired' | translation | async }}</div>
                        }
                        @if (secondsControl?.errors?.min || secondsControl?.errors?.max) {
                            <div id="timespan-seconds-range-error"><i class="fas fa-exclamation-circle"></i>{{ 'standardTimespan.validation.secondsRange' | translation | async }}</div>
                        }
                    }
                }
            </div>
        }
    </form>
    <div>
        @if (hint) {
            <small class="form-text text-muted d-block mt-1" id="timespan-hint"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
        }
    </div>
</div>
